<template>
  <div>
    <el-scrollbar style="height: 70vh">
      <el-form
        ref="manform"
        :model="manform"
        label-width="100px"
        style="padding-top: 10px"
        :rules="rules"
      >
        <el-form-item label="手机号码" prop="username">
          <el-input v-model="manform.username" :maxlength="11" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="manform.password" />
        </el-form-item>
        <el-form-item label="旧版本用户">
          <el-switch v-model="manform.isSystem" />
        </el-form-item>
        <el-form-item label="高德地图坐标">
          {{ center.toString() }}
          <div :style="{ width: '100%', height: '300px' }">
            <el-amap
              :vid="'amap-vue'"
              :zoom="zoom"
              :center="center"
              :events="events"
            >
              <el-amap-marker
                :position="marker.position"
                :events="marker.events"
                :visible="marker.visible"
                :draggable="marker.draggable"
              />
            </el-amap>
          </div>
        </el-form-item>
        <el-form-item label="平台" prop="platform">
          <el-radio-group v-model="manform.platform">
            <el-radio
              v-for="(item, index) in platformOption"
              :key="index"
              :label="item.value"
            >{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="真人认证">
          <el-switch v-model="manform.isAuthVideo" />
        </el-form-item>

        <el-form-item label="一键隐藏">
          <el-switch
            v-model="manform.isHideAll"
            active-text="已隐藏"
            inactive-text="开放中"
          />
        </el-form-item>

        <el-form-item label="活跃标签时间" prop="briskDate">
          <el-date-picker
            v-model="manform.briskDate"
            type="date"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="座驾认证" prop="carId">
          <el-select v-model="manform.carId" placeholder="请选择">
            <el-option
              v-for="(item, index) in carsOptions"
              :key="index"
              :label="item.carBrand"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="壕">
          <el-switch v-model="manform.isRich" />
        </el-form-item>
        <el-form-item label="社交账号">
          <el-form-item label="微信号1">
            <el-input v-model="manform.account.wechat1" />
          </el-form-item>
          <el-form-item label="微信号2">
            <el-input v-model="manform.account.wechat2" />
          </el-form-item>
          <el-form-item label="微信号3">
            <el-input v-model="manform.account.wechat3" />
          </el-form-item>
          <el-form-item label="QQ1">
            <el-input v-model="manform.account.QQ1" />
          </el-form-item>
          <el-form-item label="QQ2">
            <el-input v-model="manform.account.QQ2" />
          </el-form-item>
          <el-form-item label="QQ3">
            <el-input v-model="manform.account.QQ3" />
          </el-form-item>
          <el-form-item label="手机号1">
            <el-input v-model="manform.account.phone1" />
          </el-form-item>
          <el-form-item label="手机号2">
            <el-input v-model="manform.account.phone2" />
          </el-form-item>
        </el-form-item>
        <el-form-item label="昵称" prop="nickname">
          <el-input v-model="manform.nickname" />
        </el-form-item>
        <el-form-item label="生日" prop="birthday">
          <el-date-picker
            v-model="manform.birthday"
            type="date"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="头像">
          <uploadPic
            ref="uploadPic"
            :imageurl="avator"
            :width="40"
            :round="true"
            @upLoadImage="upLoadImage"
          />
        </el-form-item>
        <el-form-item label="找什么类型" prop="wantType">
          <el-radio-group v-model="manform.wantType">
            <el-radio :label="'找soulmate'">找soulmate</el-radio>
            <el-radio :label="'找女朋友'">找女朋友</el-radio>
            <el-radio :label="'找玩伴'">找玩伴</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="约玩城市">
          <el-form-item>
            <el-cascader
              v-model="playCitys.city1"
              :options="areaOptions"
              :props="props"
              style="margin-bottom: 10px"
            />
          </el-form-item>
          <el-form-item>
            <el-cascader
              v-model="playCitys.city2"
              :options="areaOptions"
              :props="props"
              style="margin-bottom: 10px"
            />
          </el-form-item>
          <el-form-item>
            <el-cascader
              v-model="playCitys.city3"
              :options="areaOptions"
              :props="props"
              style="margin-bottom: 10px"
            />
          </el-form-item>
        </el-form-item>
        <el-form-item label="职业" prop="jobs">
          <el-select v-model="manform.jobs" placeholder="请选择">
            <el-option
              v-for="(item, index) in boyJobs"
              :key="index"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="个性签名" prop="signature">
          <el-input
            v-model="manform.signature"
            :rows="2"
            type="textarea"
            style="width:200px"
          />
        </el-form-item>
        <el-form-item label="身高" prop="stature">
          <el-input v-model="manform.stature" />
          <span>CM 纯数字 140~230</span>
        </el-form-item>
        <el-form-item label="体重" prop="weight">
          <el-input v-model="manform.weight" />
          <span>KG 纯数字 30~120</span>
        </el-form-item>
        <el-form-item label="收到的标签" prop="ReceivedTabs">
          <el-checkbox-group v-model="manform.ReceivedTabs" size="mini">
            <el-checkbox-button
              v-for="(item, index) in receivedTabsoptions"
              :key="index"
              :label="item"
            >{{ item }}</el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <el-popconfirm title="确定添加？" @onConfirm="upload">
        <el-button
          slot="reference"
          :loading="button_loading"
          size="mini"
          type="primary" class="edit-button"
        >提交</el-button>
      </el-popconfirm>
    </el-scrollbar>
  </div>
</template>
<script>
import uploadPic from '@/components/Upload/UploadPic' // 引入单图片上传组件
const areaoptions = require('@/utils/regions.json') // 引入省市数据
import md5 from 'js-md5' // 引入Md5加密
export default {
  components: { uploadPic },
  data() {
    return {
      manform: {
        account: {
          QQ1: '',
          QQ2: '',
          QQ3: '',
          wechat1: '',
          wechat2: '',
          wechat3: '',
          phone1: '',
          phone2: ''
        },
        ReceivedTabs: [],
        isSystem: true,
        isAuthVideo: true,
        isRich: false,
        platform: 0,
        isHideAll: true,
        wantType: '找soulmate'
      }, // 用户基础信息
      zoom: 14, // 地图大小
      center: [113.264499, 23.130061], // 地图中心点
      marker: {
        // marker点
        position: [113.264499, 23.130061],
        visible: true,
        draggable: false
      },
      events: {
        // 地图点击事件
        click: (e) => {
          this.marker.position = [e.lnglat.lng, e.lnglat.lat]
          this.center = [e.lnglat.lng, e.lnglat.lat]
        }
      },
      dialogVisible: false,
      boyJobs: [], // 男性职业
      receivedTabsoptions: [], // 男性个人标签

      platformOption: [
        // 登录平台
        {
          label: '安卓',
          value: 0
        },
        {
          label: 'iOS',
          value: 1
        }
      ],

      carsOptions: [], // 汽车品牌
      // 约玩城市
      playCitys: {
        city1: '',
        city2: '',
        city3: ''
      },
      areaOptions: areaoptions, // 省市数据
      props: {
        // 级联选择器规则
        value: 'name',
        label: 'name',
        children: 'childs',
        emitPath: false
      },
      // 校验规则
      rules: {
        username: [
          { required: true, message: '请输入用户名称', trigger: 'blur' },
          { min: 11, max: 11, message: '请输入11位数字', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        yingxiaoLevel: [
          { required: true, message: '请选择代理等级', trigger: 'change' }
        ],
        platform: [
          { required: true, message: '请选择登陆平台', trigger: 'change' }
        ],
        vipLevel: [
          { required: true, message: '请选择会员等级', trigger: 'change' }
        ],
        vipValidDate: [
          { required: true, message: '请选择日期', trigger: 'blur' }
        ],
        briskDate: [{ required: true, message: '请选择日期', trigger: 'blur' }],
        carId: [
          { required: true, message: '请选择汽车品牌', trigger: 'change' }
        ],
        nickname: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
        birthday: [{ required: true, message: '请选择日期', trigger: 'blur' }],
        wantType: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        jobs: [{ required: true, message: '请选择职业', trigger: 'change' }],
        signature: [
          { required: true, message: '请输入个性签名', trigger: 'blur' }
        ],
        stature: [{ required: true, message: '请输入身高', trigger: 'blur' }],
        weight: [{ required: true, message: '请输入体重', trigger: 'blur' }],
        ReceivedTabs: [
          { required: true, message: '请输选择标签', trigger: 'blur' }
        ]
      },
      button_loading: false,
      avator: ''
    }
  },
  mounted() {
    const date = new Date()
    const y = date.getFullYear()
    let m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    let d = date.getDate() + 3
    d = d < 10 ? '0' + d : d
    const time = y + '-' + m + '-' + d
    this.manform.briskDate = time
    this.getConfig(), this.getCarInfos()
  },
  methods: {
    // 获取全局配置
    getConfig() {
      this.$api.global
        .getGlobalParams()
        .then((res) => {
          // var _jobs = res.boyJobs.concat(res.girlJobs)
          // this.jobs = Array.from(new Set(_jobs))
          this.boyJobs = res.boyJobs
          this.receivedTabsoptions = res.commentTabs
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
    },
    // 获取汽车信息
    getCarInfos() {
      this.$api.global
        .getAllCarInfos()
        .then((res) => {
          // console.log(res)
          this.carsOptions = res
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
    },
    // 上传图片回调函数
    upLoadImage(e) {
      console.log(e)
      this.avator = e
    },
    // 保存用户信息
    upload() {
      this.$refs.manform.validate((valid) => {
        if (valid) {
          this.button_loading = true
          // console.log(111)
          var _memberInfo = JSON.parse(JSON.stringify(this.manform))
          _memberInfo.password = md5(_memberInfo.password)
          _memberInfo.avator = this.avator
          _memberInfo.birthday = this.$moment(_memberInfo.birthday).format('YYYY-MM-DD')
          _memberInfo.briskDate = this.$moment(_memberInfo.briskDate).format('YYYY-MM-DD')
          _memberInfo.vipValidDate = this.$moment(_memberInfo.vipValidDate).format('YYYY-MM-DD')

          _memberInfo.ReceivedTabs = _memberInfo.ReceivedTabs.toString()
          _memberInfo.playCitys = []
          for (const key in this.playCitys) {
            if (this.playCitys[key] !== '') {
              _memberInfo.playCitys.push(this.playCitys[key])
            }
          }
          _memberInfo.account = JSON.stringify(_memberInfo.account)
          _memberInfo.playCitys = _memberInfo.playCitys.toString()
          _memberInfo.lon = this.center[0]
          _memberInfo.lat = this.center[1]
          //   console.log(_memberInfo);
          this.$api.global
            .addManMember(_memberInfo)
            .then((res) => {
              this.$message.success(res)
              this.$emit('close')
            })
            .catch((err) => {
              this.$message.error(err)
            })
            .finally(() => {
              this.button_loading = false
            })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form::v-deep {
  .el-cascader {
    .el-input {
      width: 100% !important;
    }
  }
  .el-input {
    width: 50%;
  }
  .el-checkbox-button {
    // background-color: red;
    margin: 0 10px 10px 0;
    .el-checkbox-button__inner {
      border: 1px solid #dcdfe6;
      border-radius: 20px;
      // border-left: 1px!important;
      // background-color: red;
    }
  }
}
</style>
